import React, { FC, useMemo } from 'react';
import { useSelector } from 'react-redux';
import { useLocation } from 'react-router';

// hooks
import useSharedBoolean from 'pages/MerchantPages/Assets/containers/EditAsset/hooks/useSharedBoolean';

// types
import { Details } from 'ducks/merchantDucks/items/types';

// selectors
import { getItemDetails, getTemplateDetails } from 'ducks/merchantDucks/items/selectors';

// components
import NavbarForm from 'pages/MerchantPages/Assets/components/Navbar/forms/NavbarForm';

const AssetNavbar: FC = () => {
  const [isAnalyticsView, , { toggle: toggleAnalyticsView }] = useSharedBoolean('isAnalyticsView');

  const { pathname } = useLocation();
  const isEditTemplate = pathname.includes('templates');
  const assetDetails = useSelector(getItemDetails);
  const templateDetails = useSelector(getTemplateDetails);

  const { id: assetId, title = '', item_type: { name: itemType = '' } = {} } = useMemo(
    () => (isEditTemplate ? templateDetails : assetDetails) as Details,
    [pathname, assetDetails, templateDetails]
  );

  return (
    <NavbarForm
      title={title}
      itemType={itemType}
      itemId={assetId}
      isAnalyticsView={isAnalyticsView}
      toggleAnalyticsView={toggleAnalyticsView}
    />
  );
};

export default AssetNavbar;
